import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../ControlBridge.module.css';

export interface UnifiedHubCompanyLink {
  slug: string;
  name: string;
}

export interface UnifiedHubChromeProps {
  personalSlug: string;
  personalLabel: string;
  companyLinks: UnifiedHubCompanyLink[];
}

export const UnifiedHubChrome: React.FC<UnifiedHubChromeProps> = ({
  personalSlug: _personalSlug,
  personalLabel,
  companyLinks,
}) => {
  const navigate = useNavigate();

  return (
    <div className={styles.unifiedHubChrome} data-testid="unified-hub-chrome">
      <div className={styles.unifiedHubContextRow}>
        <span className={styles.unifiedHubBrand}>Hub</span>
        <button
          type="button"
          className={`${styles.unifiedHubContextChip} ${styles.unifiedHubContextChipActive}`}
          aria-current="true"
          aria-label={personalLabel}
        >
          Personal · {personalLabel}
        </button>
        {companyLinks.length > 0 ? (
          <div className={styles.unifiedHubCompanyList} aria-label="Company workspaces">
            {companyLinks.slice(0, 6).map((link) => (
              <button
                key={link.slug}
                type="button"
                className={styles.unifiedHubContextChip}
                onClick={() =>
                  navigate(`/render/${encodeURIComponent(link.slug)}/control-bridge`)
                }
              >
                {link.name}
              </button>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};
